class BundleSideDrawer extends HTMLElement {
  constructor() {
    super();
    this.bundleProducts = this.querySelectorAll(".bundle-product");
    this.closeButton = this.querySelector("[bundles-drawer-close]");
    this.submitButton = this.querySelector(".bundle__submit");
    this.submitButton.addEventListener(
      "click",
      this.updateSideDrawer.bind(this)
    );
    this.closeButton.addEventListener(
      "click",
      this.closeBundleDrawer.bind(this)
    );
    this.totalPrice = 0;
    this.init();
    // Update main product price on the fly when quantity changes
    this.bundleProducts.forEach((item) => {
      const qtyInput = item.querySelectorAll(".quantity__button");
      if (qtyInput) {
        qtyInput.forEach((btn) => {
          setTimeout(() => {
            btn.addEventListener("click", this.updateTotalPrice.bind(this));
          }, 1000);
        });
      }
    });
  }

  init() {
    // Removed all counter and limit functionality
  }

  // Removed updateQuantity (counter/limit functionality)

  closeBundleDrawer(event) {
    this.classList.add("closed");
    document.body.classList.remove("bundles-overlay--active");
  }

  updateSideDrawer(event) {
    this.updateBundleLabel(event);
    this.updateTotalPrice();
    this.closeBundleDrawer();
    // Set focus back to the first [bundles-drawer-open] button
    const firstDrawerOpenBtn = document.querySelector(
      "button[bundles-drawer-open]"
    );
    if (firstDrawerOpenBtn) {
      firstDrawerOpenBtn.focus();
    }
    // Removed all limit/counter logic
  }

  // Removed updateRemainingSize (counter/limit functionality)

  updateTotalPrice(event) {
    console.log("QTY Change");
    let totalPriceAllDrawers = 0;
    document.querySelectorAll("bundle-side-drawer").forEach((drawer) => {
      let drawerTotalPrice = 0;
      drawer.querySelectorAll(".bundle-product").forEach((item) => {
        const bundleQty = parseFloat(
          item?.querySelector(".quantity__input")?.value || 0
        );
        console.log(item?.dataset);
        const price = parseFloat(item?.dataset?.price.replace(",", "") || 0);
        drawerTotalPrice += bundleQty * price;
      });
      totalPriceAllDrawers += drawerTotalPrice;
    });
    this.updateCtaPrice(totalPriceAllDrawers);
    const to = document
      .querySelector("bundle-form")
      ?.querySelector(".price__container");
    if (to) {
      to.querySelector(".price-item").textContent = `£${totalPriceAllDrawers}`;
    }
    const stickyPrice = document
      .querySelector(".product__sticky-atc")
      ?.querySelector(".price-item");
    if (stickyPrice) {
      stickyPrice.textContent = `£${totalPriceAllDrawers}`;
    }
  }

  updateCtaPrice(price) {
    console.log("Updating CTA Price to:", price);
    this.submitButton.querySelector("span").textContent = `£${price}`;
  }

  updateBundleLabel(event) {
    const dataType = this.dataset.type;
    let productDetails = "";
    this.bundleProducts.forEach((item) => {
      const bundleQty = parseFloat(
        item?.querySelector(".quantity__input")?.value || 0
      );
      const title = item?.querySelector(".bundle-product__title")?.textContent;
      if (bundleQty > 0) {
        productDetails += `${bundleQty} x ${title}, `;
      }
    });
    productDetails =
      productDetails.slice(0, -2) + ` + (£${parseFloat(this.totalPrice)})`;
    const label = document
      .querySelector(`.bundles-drawer-open[data-type="${dataType}"]`)
      ?.querySelector(".bundle-label");
    if (label) label.innerHTML = productDetails;
  }
}

customElements.define("bundle-side-drawer", BundleSideDrawer);

class BundleForm extends HTMLElement {
  constructor() {
    super();
    this.submit = this.querySelector(".product-form__submit");
    this.bundleSideDrawers = document.querySelectorAll("bundle-side-drawer");
    this.submit.addEventListener("click", this.submitHandler.bind(this));
    this.init();
  }

  init() {
    // Removed all counter/limit functionality
  }

  submitHandler(event) {
    event.preventDefault();
    let productArrayBody = [];
    this.bundleSideDrawers.forEach((drawer) => {
      const quantityInputs = drawer.querySelectorAll(".quantity__input");
      quantityInputs.forEach((input) => {
        const bundleQty = parseFloat(input.value);
        const productId = input.dataset.pid;
        if (bundleQty > 0) {
          productArrayBody.push({
            id: productId,
            quantity: bundleQty,
          });
        }
      });
    });
    // Ensure all products with valid quantities are included in the payload
    const body = {
      items: productArrayBody.filter((item) => item.quantity > 0),
    };

    const options = {
      info: {
        source: "bundle-form",
      },
      important: false,
    };

    // Check if the payload matches the expected format before sending
    if (body.items.length === 0) {
      console.error("No valid items to add to the cart.");
      return;
    }

    window.liquidAjaxCart.add(body, options);
  }
}

customElements.define("bundle-form", BundleForm);

class BundleSizeSelector extends HTMLElement {
  constructor() {
    super();
    // Removed all counter/limit functionality
  }
  // Removed updateBundle (counter/limit functionality)
}

customElements.define("bundle-size-selector", BundleSizeSelector);
